import { Position, Range } from 'vscode-languageserver-types';
import { suggest } from '@greycat/lang';
var GreyCatCompletion = /** @class */ (function () {
    function GreyCatCompletion() {
    }
    GreyCatCompletion.prototype.doComplete = function (doc, pos, gcr) {
        var position = { character: pos.character + 1, line: pos.line + 1 };
        return {
            isIncomplete: false,
            items: suggest(doc.getText(), position, gcr.lexResult.tokens.filter(function (t) { return t.tokenType.tokenName === 'Identifier'; }).map(function (t) { return t.image; })).map(function (text) { return ({
                label: text,
                textEdit: {
                    newText: text,
                    range: Range.create(pos, Position.create(pos.line, pos.character + text.length)),
                },
            }); }),
        };
    };
    return GreyCatCompletion;
}());
export default GreyCatCompletion;
//# sourceMappingURL=gc-completion.js.map